import script from "./MedPhysicsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MedPhysicsPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__